import { v4 as uuidv4} from 'uuid';

const USER_INFO_SESSION_KEY = 'user_info_session';
const SESSION_BROWSER_ID = 'session_browser_id';
const FOCUSED_MESSAGE_ID_TICKET = 'focused_message_id_ticket';
const FOCUSED_MESSAGE_ID_KNOWLEDGE = 'focused_message_id_knowledge';
const PUBLIC_PREVIOUS_DETAIL_URL = 'public_previous_detail_url';

//base utils
function setItem(key, value) {
    sessionStorage.setItem(key, value);
}

function getItem(key) {
    const value = sessionStorage.getItem(key);
    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}

function deleteItem(key) {
    sessionStorage.removeItem(key);
}

function getUserInfoSession(){
    return getItem(USER_INFO_SESSION_KEY);
}
function deleteUserInfoSession(){
    deleteItem(USER_INFO_SESSION_KEY)
}

function setSessionBrowserId() {
    const sessionId = `solutiondesk_${uuidv4()}`
    setItem(SESSION_BROWSER_ID, sessionId);
    return sessionId;
}

function getSessionBrowserId(){
    let sessionBrowserId = getItem(SESSION_BROWSER_ID);
    if (!sessionBrowserId) {
        sessionBrowserId = setSessionBrowserId();
    }
    return sessionBrowserId;
}

function deleteSessionBrowserId(){
    deleteItem(SESSION_BROWSER_ID)
}

function getFocusedMsgIdTicket() {
    return getItem(FOCUSED_MESSAGE_ID_TICKET);
}

function setFocusedMsgIdTicket(value) {
    return setItem(FOCUSED_MESSAGE_ID_TICKET, value);
}

function deleteFocusedMsgIdTicket() {
    deleteItem(FOCUSED_MESSAGE_ID_TICKET);
}

function getFocusedMsgIdKL() {
    return getItem(FOCUSED_MESSAGE_ID_KNOWLEDGE);
}

function setFocusedMsgIdKL(value) {
    return setItem(FOCUSED_MESSAGE_ID_KNOWLEDGE, value);
}

function deleteFocusedMsgIdKL() {
    deleteItem(FOCUSED_MESSAGE_ID_KNOWLEDGE);
}

function setPublicPreviousDetailUrl(value) {
    setItem(PUBLIC_PREVIOUS_DETAIL_URL, value);
}

function getPublicPreviousDetailUrl() {
    return getItem(PUBLIC_PREVIOUS_DETAIL_URL);
}

function deletePublicPreviousDetailUrl() {
    deleteItem(PUBLIC_PREVIOUS_DETAIL_URL);
}

const sessionStorageUtil = {
    getUserInfoSession,
    deleteUserInfoSession,
    setSessionBrowserId,
    getSessionBrowserId,
    deleteSessionBrowserId,
    getFocusedMsgIdTicket,
    setFocusedMsgIdTicket,
    deleteFocusedMsgIdTicket,
    getFocusedMsgIdKL,
    setFocusedMsgIdKL,
    deleteFocusedMsgIdKL,
    setPublicPreviousDetailUrl,
    getPublicPreviousDetailUrl,
    deletePublicPreviousDetailUrl
}

export default sessionStorageUtil;

